<template>
  <div class="search-engine container" :class="{ 'modify-width': notSearch }">
    <b-modal
      :active.sync="loader.isLoading"
      :can-cancel="[false, false, false]"
    >
      <div id="loading">
        <!-- <bounce-loader :color="loader.spinnerColor" size="14px" class="beat-loader"></bounce-loader> -->
        <h2 class="search-details">
          <div class="location-time align-left">
            {{ departureLocation.airportName }}
            <br />
            <small>({{ displayDate(departureDate) }})</small>
          </div>
          <b-icon icon="swap-horizontal"></b-icon>
          <div class="location-time align-right">
            <small
              >({{
                returnDate ? displayDate(returnDate) : "arriving at"
              }})</small
            >
            <br />
            {{
              tripType == "multi"
                ? "multi Itinerary"
                : arrivalLocation.airportName
            }}
          </div>
        </h2>
      </div>
      <div class="savings-prompt">
        <div class="info-box">
          <div class="heading not-center">
            <b>Did you know?</b>
          </div>
          <div class="content did-you-know">
            <ul>
              <li class="bullet-point">
                You are booking with a certified ASATA travel agent
              </li>
              <li class="bullet-point">
                Professional travel experts are just a phone call away
              </li>
            </ul>
          </div>
        </div>
      </div>
    </b-modal>
    <div class="block">
      <b-radio
        ref="input"
        :key="typeKey"
        v-model="tripType"
        name="tripType"
        native-value="return"
        >Return</b-radio
      >
      <b-radio v-model="tripType" name="tripType" native-value="oneway"
        >Oneway</b-radio
      >
      <b-radio v-model="tripType" name="tripType" native-value="multi"
        >Multi-city</b-radio
      >
    </div>
    <b-field grouped group-multiline expanded class="has-field-margin">
      <b-field label="From" :label-position="labelPosition" expanded>
        <b-autocomplete
          :data="filteredAirports"
          ref="departureLocation"
          placeholder="Country, City or Airport"
          :keep-first="true"
          :open-on-focus="true"
          field="airportName"
          autocomplete="new-password"
          @typing="getAsyncAirports"
          @select="
            (option) => {
              departureAirportOnly = option.airportName
                .toLowerCase()
                .includes('all')
                ? false
                : true;
              departureLocation = option;
              filteredAirports = [];
              this.focusArrivalLocation();
            }
          "
        >
          <template slot-scope="props">
            <div class="media">
              <div class="media-left">
                <b-icon
                  v-if="props.option.airportName.toLowerCase().includes('all')"
                  icon="earth"
                ></b-icon>
                <b-icon v-else icon="airplane"></b-icon>
              </div>
              <div class="media-content">
                {{ props.option.airportName }}
                <b
                  v-if="!props.option.airportName.toLowerCase().includes('all')"
                  >, {{ props.option.airportCode }}</b
                >
                <br />
                <small
                  >{{ props.option.city }}, {{ props.option.country }}</small
                >
              </div>
            </div>
          </template>
        </b-autocomplete>
      </b-field>
      <b-field
        label="To"
        :label-position="labelPosition"
        expanded
        :class="{ last: tripType == 'return' }"
      >
        <b-autocomplete
          :data="filteredAirports"
          placeholder="Country, City or Airport"
          field="airportName"
          :keep-first="true"
          ref="arrivalLocation"
          :open-on-focus="true"
          autocomplete="new-password"
          @typing="getAsyncAirports"
          @select="
            (option) => {
              arrivalAirportOnly = option.airportName
                .toLowerCase()
                .includes('all')
                ? false
                : true;
              arrivalLocation = option;
              filteredAirports = [];
              this.focusOutboundDate();
            }
          "
        >
          <template slot-scope="props">
            <div class="media">
              <div class="media-left">
                <b-icon
                  v-if="props.option.airportName.toLowerCase().includes('all')"
                  icon="earth"
                ></b-icon>
                <b-icon v-else icon="airplane"></b-icon>
              </div>
              <div class="media-content">
                {{ props.option.airportName }}
                <b
                  v-if="!props.option.airportName.toLowerCase().includes('all')"
                  >, {{ props.option.airportCode }}</b
                >
                <br />
                <small
                  >{{ props.option.city }}, {{ props.option.country }}</small
                >
              </div>
            </div>
          </template>
        </b-autocomplete>
      </b-field>
      <b-field
        v-if="tripType == 'oneway' || tripType == 'multi'"
        class="last"
        label="Depart"
        :label-position="labelPosition"
        expanded
      >
        <b-datepicker
          placeholder="Click to select..."
          :open-on-focus="true"
          :focused-date="minDepartureDate"
          ref="outboundDate"
          :years-range="[0, 1]"
          :min-date="minDepartureDate"
          :max-date="maxDepartureDate"
          @input="tripType == 'oneway' ? focusSearch() : null"
          v-model="departureDate"
        ></b-datepicker>
      </b-field>
    </b-field>
    <b-field
      v-if="tripType == 'return'"
      grouped
      class="has-field-margin"
      group-multiline
      expanded
    >
      <b-field label="Depart" :label-position="labelPosition" expanded>
        <b-datepicker
          placeholder="Click to select..."
          :min-date="minDepartureDate"
          :max-date="maxDepartureDate"
          :open-on-focus="true"
          :focused-date="minDepartureDate"
          ref="outboundDate"
          @input="focusReturnDate()"
          v-model="departureDate"
        ></b-datepicker>
      </b-field>
      <b-field
        label="Return"
        :label-position="labelPosition"
        expanded
        class="last"
      >
        <b-datepicker
          placeholder="Click to select..."
          :open-on-focus="true"
          ref="returnDate"
          :min-date="minReturnDate"
          :max-date="maxDepartureDate"
          :focused-date="minReturnDate"
          @input="focusSearch()"
          v-model="returnDate"
        ></b-datepicker>
      </b-field>
    </b-field>
    <div v-if="tripType == 'multi'">
      <b-field
        v-for="(flight, index) in multiFlights"
        :key="flight.key"
        grouped
        group-multiline
        expanded
        class="has-field-margin"
      >
        <hr class="multi-divider" />
        <b-field label="From" :label-position="labelPosition" expanded>
          <b-autocomplete
            :data="filteredAirports"
            placeholder="Country, City or Airport"
            :keep-first="true"
            :open-on-focus="true"
            field="airportName"
            autocomplete="new-password"
            @typing="getAsyncAirports"
            @select="
              (option) => {
                flight.departureAirportOnly = option.airportName
                  .toLowerCase()
                  .includes('all')
                  ? false
                  : true;
                flight.departureLocation = option;
                filteredAirports = [];
              }
            "
          >
            <template slot-scope="props">
              <div class="media">
                <div class="media-left">
                  <b-icon
                    v-if="
                      props.option.airportName.toLowerCase().includes('all')
                    "
                    icon="earth"
                  ></b-icon>
                  <b-icon v-else icon="airplane"></b-icon>
                </div>
                <div class="media-content">
                  {{ props.option.airportName }}
                  <b
                    v-if="
                      !props.option.airportName.toLowerCase().includes('all')
                    "
                    >, {{ props.option.airportCode }}</b
                  >
                  <br />
                  <small
                    >{{ props.option.city }}, {{ props.option.country }}</small
                  >
                </div>
              </div>
            </template>
          </b-autocomplete>
        </b-field>
        <b-field label="To" :label-position="labelPosition" expanded>
          <b-autocomplete
            :data="filteredAirports"
            placeholder="Country, City or Airport"
            field="airportName"
            :keep-first="true"
            ref="arrivalLocation"
            :open-on-focus="true"
            autocomplete="new-password"
            @typing="getAsyncAirports"
            @select="
              (option) => {
                flight.arrivalAirportOnly = option.airportName
                  .toLowerCase()
                  .includes('all')
                  ? false
                  : true;
                flight.arrivalLocation = option;
                filteredAirports = [];
              }
            "
          >
            <template slot-scope="props">
              <div class="media">
                <div class="media-left">
                  <b-icon
                    v-if="
                      props.option.airportName.toLowerCase().includes('all')
                    "
                    icon="earth"
                  ></b-icon>
                  <b-icon v-else icon="airplane"></b-icon>
                </div>
                <div class="media-content">
                  {{ props.option.airportName }}
                  <b
                    v-if="
                      !props.option.airportName.toLowerCase().includes('all')
                    "
                    >, {{ props.option.airportCode }}</b
                  >
                  <br />
                  <small
                    >{{ props.option.city }}, {{ props.option.country }}</small
                  >
                </div>
              </div>
            </template>
          </b-autocomplete>
        </b-field>
        <b-field
          class="last"
          label="Depart"
          :label-position="labelPosition"
          expanded
        >
          <b-datepicker
            placeholder="Click to select..."
            :open-on-focus="true"
            :years-range="[0, 1]"
            ref="outboundDate"
            :min-date="lastDate(index > 0 ? multiFlights[index - 1] : null)"
            :max-date="maxDepartureDate"
            :focused-date="lastDate(index > 0 ? multiFlights[index - 1] : null)"
            v-model="flight.departureDate"
          ></b-datepicker>
        </b-field>
      </b-field>
    </div>
    <b-message v-if="isQuarentine" type="is-danger"
      >Due to Covid-19 airlines are no longer permitted to fly until after the
      lockdown restrictions have been lifted.</b-message
    >
    <div class="buttons">
      <button
        @click="addNewmultiFlight"
        class="button is-rounded outlined add-flight"
        v-if="tripType == 'multi' && multiFlights.length < 5"
      >
        <b-icon icon="plus-circle" type="is-secondary"></b-icon>
        <span>Add Flight</span>
      </button>
      <button
        @click="removeMulticityFlight"
        class="button is-rounded outlined remove-flight"
        v-if="tripType == 'multi' && multiFlights.length >= 1"
      >
        <b-icon icon="minus-circle" type="is-warning"></b-icon>
        <span>Remove Flight</span>
      </button>
      <b-message
        type="is-danger"
        v-if="tripType !== 'multi' && (!validPassengers.success || errors.length > 0)"
      >
        <div v-for="(error, index) in validPassengers.errors" :key="index">
          {{ error }}
        </div>
        <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
      </b-message>
      <b-dropdown class="options-dropdown">
        <button class="button" slot="trigger" role="button">
          <span>{{ numberOfPassangers }} Travellers, {{ preferredCabin }}</span>
          <b-icon icon="menu-down"></b-icon>
        </button>
        <b-dropdown-item
          aria-role="menu-item"
          :class="{ 'minify-dropdown': this.$route.name !== 'search' }"
          :focusable="false"
          custom
        >
          <div class="easy-flex">
            <b-field
              v-if="this.$route.name === 'search'"
              label="Departure Time"
            >
              <b-select v-model="departureTime" expanded required>
                <option value="AnyTime">Any time</option>
                <option value="Morning">Morning</option>
                <option value="Afternoon">Afternoon</option>
                <option value="Evening">Evening</option>
              </b-select>
            </b-field>
            <b-field
              :label="this.$route.name === 'search' ? 'Cabin Class' : null"
              :expanded="this.$route.name !== 'search' ? true : null"
              :class="{ 'margin-bottom': this.$route.name !== 'search' }"
            >
              <b-select
                :size="this.$route.name === 'search' ? null : 'is-small'"
                v-model="preferredCabin"
                expanded
                required
              >
                <option value="Economy">Economy</option>
                <option value="Premium">Premium</option>
                <option value="Business">Business</option>
                <option value="First">First</option>
              </b-select>
            </b-field>
          </div>
          <b-field label="Adults">
            <b-numberinput
              :size="this.$route.name === 'search' ? null : 'is-small'"
              min="1"
              :max="9 - children - infants"
              v-model="adults"
              controls-rounded
            ></b-numberinput>
          </b-field>
          <b-field label="Children">
            <b-numberinput
              :size="this.$route.name === 'search' ? null : 'is-small'"
              min="0"
              :max="9 - adults - infants"
              v-model="children"
              controls-rounded
            ></b-numberinput>
          </b-field>
          <b-field label="Infants">
            <b-numberinput
              :size="this.$route.name === 'search' ? null : 'is-small'"
              min="0"
              :max="Math.min(adults, 9 - adults - children)"
              v-model="infants"
              controls-rounded
            ></b-numberinput>
          </b-field>
          <b-message type="is-danger" v-if="correctionMessages.length > 0">
            <div v-for="(message, index) in correctionMessages" :key="index">
              {{ message }}
            </div>
          </b-message>
        </b-dropdown-item>
      </b-dropdown>
      <b-button
        ref="search"
        class="last"
        @click="searchFlights(false)"
        type="is-primary"
        >Search</b-button
      >
      <b-message
        type="is-danger"
        v-if="tripType === 'multi' && (!validPassengers.success || errors.length > 0)"
      >
        <div v-for="(error, index) in validPassengers.errors" :key="index">
          {{ error }}
        </div>
        <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
      </b-message>
    </div>
  </div>
</template>

<script>
import Api from "@/services/Api.service.js";
import debounce from "lodash/debounce";
import { locations } from "@/assets/json/locations.json";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "SearchEngine",
  data() {
    const today = new Date();
    return {
      labelPosition: "on-border",
      tripType: "return",
      typeKey: 50,
      minDepartureDate: this.getMinDepartureDate(),
      maxDepartureDate: new Date(
        today.getFullYear(),
        today.getMonth() + 11,
        today.getDate(),
        today.getHours(),
      ),
      allAirports: locations,
      filteredAirports: [],
      departureLocation: {
        airportName: undefined,
        airportCode: undefined,
      },
      arrivalLocation: {
        airportName: undefined,
        airportCode: undefined,
      },
      departureDate: undefined,
      returnDate: undefined,

      adults: 1,
      children: 0,
      infants: 0,
      preferredCabin: "Economy",
      multiFlights: [],
      flights: [],
      departureAirportOnly: true,
      arrivalAirportOnly: true,
      departureTime: "AnyTime",
      errors: [],
      validSearch: true,
      loader: {
        isLoading: false,
        stepCount: 3000,
        backgroundColor: "linear-gradient(to right, lightgray, gray)",
        opacity: 0.5,
        spinnerSize: "15px",
        spinnerColor: "#0072CF",
        currentStep: "Preparing links.",
        progressSteps: ["Connecting to providers.", "Fetching latest flights."],
      },
      correctionMessages: [],
    };
  },
  computed: {
    ...mapState(["priorSearch"]),
    notSearch() {
      return this.$route.name == "results";
    },
    validPassengers() {
      let errors = [];
      let success = true;
      if (this.infants + this.adults + this.children > 9) {
        errors.push("Maximum of 9 passengers allowed.");
        success = false;
      }
      if (this.infants > this.adults) {
        errors.push("Only one infant per passenger allowed.");
        success = false;
      }
      if (this.children > 0 && this.adults === 0) {
        errors.push("Children must be accompanied by an adult.");
        success = false;
      } else if (this.adults === 0) {
        errors.push("At least one adult passenger required");
        success = false;
      }
      return {
        success: success,
        errors: errors,
      };
    },
    isQuarentine() {
      return new Date() < new Date(2020, 6, 1);
    },
    urlSearchParameters() {
      return this.$store.state.urlSearchParameters;
    },
    numberOfPassangers() {
      return this.children + this.infants + this.adults;
    },
    minReturnDate() {
      let result;
      if (this.departureDate) {
        result = this.departureDate;
        if (this.returnDate < result) {
          this.returnDate = result;
        }
      } else {
        result = this.minDepartureDate;
      }
      return result;
    },
  },
  mounted() {
    if (this.$route.name === "search") {
      this.$store.commit("notDomesticReturn");
    }
    if (this.priorSearch.exists) {
      this.arrivalLocation = this.priorSearch.arrivalLocation;
      this.departureLocation = this.priorSearch.departureLocation;
      this.departureTime = this.priorSearch.departureTime;
      this.adults = this.priorSearch.adults;
      this.children = this.priorSearch.children;
      this.infants = this.priorSearch.infants;
      this.preferredCabin = this.priorSearch.preferredCabin;
      this.departureDate = this.priorSearch.departureDate;
      this.returnDate = this.priorSearch.returnDate;
      this.multiFlights = this.priorSearch.multiFlights;
      this.tripType = this.priorSearch.tripType;
      this.$refs.arrivalLocation.setSelected(this.priorSearch.arrivalLocation);
      this.$refs.departureLocation.setSelected(
        this.priorSearch.departureLocation,
      );
    }
  },
  methods: {
    getMinDepartureDate() {
      let today = new Date();
      let timelimit = this.add_minutes(today, 240);
      if (this.isToday(timelimit)) {
        return new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - 1,
          today.getHours(),
        );
      } else {
        return new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
          today.getHours(),
        );
      }
    },
    add_minutes(dt, minutes) {
      return new Date(dt.getTime() + minutes * 60000);
    },
    isToday(someDate) {
      const today = new Date();
      return (
        someDate.getDate() == today.getDate() &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear()
      );
    },
    lastDate(lastFlight) {
      let result;
      if (lastFlight) {
        result = lastFlight.departureDate;
      } else {
        result = this.departureDate
          ? this.departureDate
          : this.minDepartureDate;
      }
      return result;
    },
    displayDate(date) {
      return moment(date).format("MMMM Do YYYY");
    },
    focusArrivalLocation() {
      this.errors = [];
      this.$refs.arrivalLocation.focus();
    },
    focusOutboundDate() {
      this.errors = [];
      this.$refs.outboundDate.focus();
    },
    focusReturnDate() {
      this.errors = [];
      this.$refs.returnDate.focus();
    },
    focusSearch() {
      this.errors = [];
      this.$refs.search.$el.focus();
    },
    addNewmultiFlight: function() {
      if (this.multiFlights.length < 5) {
        this.multiFlights.push({
          departureDate: undefined,
          departureAirport: undefined,
          arrivalAirport: undefined,
        });
      }
    },
    removeMulticityFlight: function() {
      if (this.multiFlights.length >= 1) {
        this.multiFlights.pop();
      }
    },
    stepCurrentProgress: function() {
      const it = this.loader.progressSteps[Symbol.iterator]();
      const int = setInterval(() => {
        const next = it.next();
        if (!next.done) {
          this.loader.currentStep = next.value;
        } else {
          clearInterval(int);
        }
      }, this.loader.stepCount);
    },
    constructFlightsArray: function(urlParams = null) {
      let context = urlParams ? urlParams : this;
      if (context.tripType == "return") {
        this.flights.push({
          origin: {
            value: {
              code: context.departureLocation.airportCode,
              type: context.departureLocation.airportName
                .toLowerCase()
                .includes("all")
                ? "city"
                : "airport",
            },
          },
          destination: {
            value: {
              code: context.arrivalLocation.airportCode,
              type: context.arrivalLocation.airportName
                .toLowerCase()
                .includes("all")
                ? "city"
                : "airport",
            },
          },
          departDate: moment(context.departureDate).format("YYYY-MM-DD"),
          returnDate:
            context.tripType == "return"
              ? moment(context.returnDate).format("YYYY-MM-DD")
              : null,
        });
      } else {
        this.flights.push({
          origin: {
            value: {
              code: context.departureLocation.airportCode,
              type: context.departureLocation.airportName
                .toLowerCase()
                .includes("all")
                ? "city"
                : "airport",
            },
          },
          destination: {
            value: {
              code: context.arrivalLocation.airportCode,
              type: context.arrivalLocation.airportName
                .toLowerCase()
                .includes("all")
                ? "city"
                : "airport",
            },
          },
          departDate: moment(context.departureDate).format("YYYY-MM-DD"),
        });
      }
      if (context.tripType == "multi") {
        if (context.multiFlights) {
          context.multiFlights.forEach((flight) => {
            this.flights.push({
              origin: {
                value: {
                  code: flight.departureLocation.airportCode,
                  type: flight.departureLocation.airportName
                    .toLowerCase()
                    .includes("all")
                    ? "city"
                    : "airport",
                },
              },
              destination: {
                value: {
                  code: flight.arrivalLocation.airportCode,
                  type: flight.arrivalLocation.airportName
                    .toLowerCase()
                    .includes("all")
                    ? "city"
                    : "airport",
                },
              },
              departDate: moment(flight.departureDate).format("YYYY-MM-DD"),
            });
          });
        } else {
          if (context.multi1_departureDate) {
            this.flights.push({
              departureDate: moment(context.multi1_departureDate).format(
                "DD/MM/YYYY",
              ),
              departureAirport: context.multi1_departureAirport,
              arrivalAirport: context.multi1_arrivalAirport,
              departureAirportOnly: !this.departureAirportOnly
                ? "false"
                : "true",
              arrivalAirportOnly: !this.arrivalAirportOnly ? "false" : "true",
            });
          }
          if (context.multi2_departureDate) {
            this.flights.push({
              departureDate: moment(context.multi2_departureDate).format(
                "DD/MM/YYYY",
              ),
              departureAirport: context.multi2_departureAirport,
              arrivalAirport: context.multi2_arrivalAirport,
              departureAirportOnly: !this.departureAirportOnly
                ? "false"
                : "true",
              arrivalAirportOnly: !this.arrivalAirportOnly ? "false" : "true",
            });
          }
          if (context.multi3_departureDate) {
            this.flights.push({
              departureDate: moment(context.multi3_departureDate).format(
                "DD/MM/YYYY",
              ),
              departureAirport: context.multi3_departureAirport,
              arrivalAirport: context.multi3_arrivalAirport,
              departureAirportOnly: !this.departureAirportOnly
                ? "false"
                : "true",
              arrivalAirportOnly: !this.arrivalAirportOnly ? "false" : "true",
            });
          }
        }
      }
    },
    getAsyncAirports: debounce(function(query) {
      this.errors = [];
      if (query.length) {
        let lowerCaseQuery = query.toLowerCase();
        this.filteredAirports = this.allAirports.filter(
          (location) =>
            location.airportCode.toLowerCase().includes(lowerCaseQuery) ||
            location.airportName.toLowerCase().includes(lowerCaseQuery) ||
            location.city.toLowerCase().includes(lowerCaseQuery) ||
            location.country.toLowerCase().includes(lowerCaseQuery),
        );
        this.filteredAirports = this.filteredAirports.reduce((acc, element) => {
          if (element.airportCode.toLowerCase() === query.toLowerCase()) {
            return [element, ...acc];
          }
          return [...acc, element];
        }, []);
      }
    }, 300),
    getLocationFromAirportCode(code) {
      return this.allAirports.find((location) => location.airportCode == code);
    },
    isSouthAfricanAirport(airportCode) {
      let location = this.allAirports.find((airport) => {
        return airport.airportCode == airportCode;
      });
      if (location.country.toLowerCase() == "south africa") {
        return true;
      } else {
        return false;
      }
    },
    validSearchCheck(urlParams = null) {
      let context = urlParams ? urlParams : this;
      if (
        !context.departureLocation.airportCode ||
        !context.arrivalLocation.airportCode ||
        !context.departureDate
      ) {
        this.errors.push("All search fields required.");
        return false;
      } else if (context.tripType == "return" && !context.returnDate) {
        this.errors.push("Please select a return date.");
        return false;
      } else if (
        context.departureLocation.city == context.arrivalLocation.city
      ) {
        this.errors.push("Origin and destination cannot be in the same city.");
        return false;
      }
      return true;
    },
    async searchFlights(isUrlSearch) {
      if (
        !isUrlSearch &&
        (!this.validPassengers.success || !this.validSearchCheck())
      ) {
        this.$buefy.toast.open({
          message: "Invalid Search!",
          type: "is-warning",
          position: "is-top",
        });
        return false;
      }
      this.$store.commit("recordSearch", {
        exists: true,
        arrivalLocation: this.arrivalLocation,
        departureLocation: this.departureLocation,
        departureTime: this.departureTime,
        adults: this.adults,
        children: this.children,
        infants: this.infants,
        preferredCabin: this.preferredCabin,
        departureDate: this.departureDate,
        returnDate: this.returnDate,
        multiFlights: this.multiFlights,
        tripType: this.tripType,
      });
      if (!isUrlSearch) {
        this.constructFlightsArray();
      }
      this.$store.dispatch("resetAll");
      let searchBody = this.createSearchBody();
      this.$store.commit("setSearchParameters", searchBody);
      try {
        this.loader.isLoading = true;
        if (this.$route.name === "results") {
          this.loader.isLoading = false;
          this.$parent.close();
        }
        console.time("search request time:");
        this.$store.commit("toggleSearchInProgress", true);
        this.stepCurrentProgress();
        setTimeout(() => {
          if (this.$route.name === "search") {
            this.$router.push("/results");
          }
        }, this.loader.stepCount * 3);
        this.checkForDomesticFlight();
        const result = await Api.search(searchBody);
        this.$store.commit("setSearchResults", result.data.response);
        if (this.$route.name === "search") {
          this.$router.push("/results");
        }
        this.$store.commit("orderResults", "Price");
      } catch (error) {
        this.$store.commit("setSearchResults", { errors: error });
      } finally {
        console.timeEnd("search request time:");
        this.$store.commit("toggleSearchInProgress", false);
      }
    },
    createSearchBody() {
      return {
        tripType: this.tripType,
        sessionID: this.$store.state.session,
        travellers: {
          adults: this.adults,
          children: this.children,
          infants: this.infants,
        },
        moreOptions: {
          preferredCabins: {
            value: this.preferredCabin.toUpperCase(),
            display: this.preferredCabin,
          },
          isCalendarSearch: false,
        },
        itineraries: this.flights,
      };
    },
    checkForDomesticFlight() {
      // For each itinerary in flights array, check if orgin.value.code and destination.value.code are in South Africa from locations list.
      // If not, set isInternational to true.
      let isInternational = false;
      this.flights.forEach(itinerary => {
        if (!this.isSouthAfrica(itinerary.origin.value.code) || !this.isSouthAfrica(itinerary.destination.value.code)) {
          isInternational = true;
        }
      });
      this.$store.commit("setIsInternational", isInternational);
    },
    isSouthAfrica(code) {
      let location = this.allAirports.find(airport => {
        return airport.airportCode == code;
      });
      if (location.country.toLowerCase() == "south africa") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
      adults: function(newVal) {
        if (newVal >= 10) {
          this.adults = parseInt(newVal.toString()[0]);
          this.correctionMessages = ["Only single-digit numbers allowed."];
          setTimeout(() => { this.correctionMessages = []; }, 3000);
        }
        if (newVal > 9 - this.children - this.infants) {
          this.adults = 9 - this.children - this.infants;
          this.correctionMessages = ["Maximum of 9 passengers allowed."];
          setTimeout(() => { this.correctionMessages = []; }, 3000);
        }
      },
    children: function(newVal) {
      if (newVal >= 10) {
        this.children = parseInt(newVal.toString()[0]);
        this.correctionMessages = ["Only single-digit numbers allowed."];
        setTimeout(() => { this.correctionMessages = []; }, 3000);
      }
      if (newVal > 9 - this.adults - this.infants) {
        this.children = 9 - this.adults - this.infants;
        this.correctionMessages = ["Maximum of 9 passengers allowed."];
        setTimeout(() => { this.correctionMessages = []; }, 3000);
      }
    },
    infants: function(newVal) {
      if (newVal >= 10) {
        this.infants = parseInt(newVal.toString()[0]);
        this.correctionMessages = ["Only single-digit numbers allowed."];
        setTimeout(() => { this.correctionMessages = []; }, 3000);
      }
      const maxInfants = Math.min(this.adults, 9 - this.adults - this.children);
      if (newVal > maxInfants) {
        this.infants = maxInfants;
        this.correctionMessages = ["Only one infant per adult passenger allowed."];
        setTimeout(() => { this.correctionMessages = []; }, 3000);
      }
    },
    urlSearchParameters: function(newVal) {
      // if url parameters have been set, generate correct data format
      // and make instant search
      console.log("automatically calling search from url parameters");
      this.departureLocation = this.getLocationFromAirportCode(
        newVal.departureAirport,
      );
      this.arrivalLocation = this.getLocationFromAirportCode(
        newVal.arrivalAirport,
      );
      newVal.departureLocation = this.getLocationFromAirportCode(
        newVal.departureAirport,
      );
      newVal.arrivalLocation = this.getLocationFromAirportCode(
        newVal.arrivalAirport,
      );
      if (newVal.multi1_departureAirportl) {
        newVal.multi1_departureAirport = this.getLocationFromAirportCode(
          newVal.multi1_departureAirport,
        );
        newVal.multi1_arrivalAirport = this.getLocationFromAirportCode(
          newVal.multi1_arrivalAirport,
        );
      }
      if (newVal.multi2_departureAirportl) {
        newVal.multi2_departureAirport = this.getLocationFromAirportCode(
          newVal.multi2_departureAirport,
        );
        newVal.multi2_arrivalAirport = this.getLocationFromAirportCode(
          newVal.multi2_arrivalAirport,
        );
      }
      if (newVal.multi3_departureAirportl) {
        newVal.multi3_departureAirport = this.getLocationFromAirportCode(
          newVal.multi3_departureAirport,
        );
        newVal.multi3_arrivalAirport = this.getLocationFromAirportCode(
          newVal.multi3_arrivalAirport,
        );
      }
      this.tripType = newVal.tripType;
      this.adults = Number(newVal.adults);
      this.children = Number(newVal.children);
      this.infants = Number(newVal.infants);
      this.preferredCabin = newVal.preferredCabin;
      this.constructFlightsArray(newVal);
      this.searchFlights(true);
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/settings.scss";

.search-engine {
  background: $light;
  margin: auto;
  padding: $standard-padding;
  border-radius: 8px;
  box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
  max-width: 700px !important;
}

.easy-flex {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.75em;
}

.modify-width {
  width: 600px;
  margin-bottom: 4rem !important;
}

a.dropdown-item {
  padding-right: 1rem;
}

.savings-prompt {
  background: $gradient-color;
  color: $light;
  padding: 1em;
  width: 300px;
  margin: auto;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  .heading,
  .content {
    color: $light;
    text-align: center;
  }
  .heading {
    font-size: 1.3em;
    font-weight: bold;
    text-transform: capitalize;
  }
}

.has-field-margin {
  margin-bottom: 1rem !important;
}
.last {
  margin-right: 0.75rem !important;
}

.not-center {
  text-align: left;
}

.multi-divider {
  width: 100%;
  margin-top: 0;
}
.buttons {
  justify-content: flex-start;
}
.options-dropdown {
  margin-right: 0.75rem;
  margin-left: auto !important;
}

.media {
  align-items: center;
}

#loading {
  background: $light;
  margin: auto;
  padding: 2em;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
  display: flex;
  width: 300px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .heading {
    margin-top: 0.75em;
    font-size: 1.6em;
    font-weight: bold;
    white-space: nowrap;
  }
}

.did-you-know {
  max-width: 280px;
  margin: auto;
  display: flex;
  justify-content: space-between;
}

.bullet-point {
  text-align: left;
}

.search-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  min-height: 80px;
  width: 100%;
}

.location-time {
  font-size: 20px;
  font-weight: 500;
  width: 100%;
  small {
    color: darken($grey, 30%);
    font-size: 14px;
  }
}

.beat-loader {
  margin-bottom: 0.75em;
}

.align-left {
  text-align: center;
  margin-bottom: 0.75em;
}

.align-right {
  text-align: center;
  margin-top: 0.75em;
}

@media (max-width: 768px) {
  .media-content {
    overflow-x: hidden !important;
    font-size: 10px !important;
  }
}

@media (min-width: 781px) {
  #loading {
    width: 400px;
  }

  .align-left {
    text-align: left;
    margin-bottom: 0.75em;
  }

  .align-right {
    text-align: right;
    margin-top: 0.75em;
  }

  .bottom-right {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .did-you-know {
    max-width: 400px;
  }

  .easy-flex {
    flex-direction: row;
    margin-bottom: 0;
  }

  .easy-flex > * + * {
    margin-left: 0.75em;
  }

  .savings-prompt {
    width: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .search-engine {
    min-width: 700px;
    box-shadow: 3px 6px 8px rgba(32, 33, 36, 0.7);
    border: solid $primary-color 0.8px;
  }
}

@media (max-width: 781px) {
  .buttons {
    display: flex;
    flex-wrap: wrap;
    * {
      width: 100%;
    }
  }
  .options-dropdown {
    .button {
      width: 100%;
    }
  }
}
</style>

<style lang="scss">
.modal .animation-content {
  flex-direction: column;
}

.animation-content {
  background: none !important;
}

@media (max-width: 781px) {
  .dropdown-trigger {
    width: 100% !important;
  }
}

@media (min-width: 781px) {
  .buttons .dropdown-menu {
    min-width: 300px;
  }

  .minify-dropdown .dropdown-menu {
    min-width: 200px;
  }

  .minify-dropdown .label {
    font-size: 0.7rem;
  }

  .margin-bottom {
    margin-bottom: 0.75em;
  }

  .autocomplete .dropdown-menu {
    max-width: fit-content !important;
  }
}

.dropdown-menu {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.dropdown-menu {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>
